// extracted by mini-css-extract-plugin
module.exports = {"section":"aed17b9412--section--hMaY8","tablet":"aed17b9412--tablet--wdjey","desktop":"aed17b9412--desktop--ThD1S"};